import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import axios from 'axios';
import { computed, inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import WCProductRowModern from '@/components/WCProductRow/WCProductRowModern.vue';
import AnalyticsService from '@/services/analytics.service';
import TrackableEventConstants from '@/constants/TrackableEventConstants';
import { ENTRY_METHOD, type EntryMethod } from '@/models/entities/cart/entry-method';
import { configurationKey } from '@/injections';
import usePlatform from '@/modules/platform/composables/usePlatform';
import useCardLimitInRow from '@/composables/useCardLimitInRow';
import type ItemDetail from '@/models/entities/items/item-detail';

interface Props {
  entryMethod?: EntryMethod;
  historyWindowDays?: number;
  rowSizeLimit?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WCPurchaseAgainModern',
  props: {
    entryMethod: { default: ENTRY_METHOD.RECOMMENDATION_PURCHASE_AGAIN },
    historyWindowDays: { default: 90 },
    rowSizeLimit: { default: 12 }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const { t } = useI18n();
const { platform } = usePlatform();
const configuration = inject(configurationKey);

const isGuest = computed(() => store.getters['user/isGuest']);
const getUser = computed(() => store.getters['user/getUser']);
const canShowPurchaseAgain = computed(
  () => !isGuest.value && Boolean(configuration?.pastItemsEnabled),
);

const products = ref<ItemDetail[]>([]);
const totalCount = ref(0);
const rowRef = ref<HTMLElement | null>(null);
const getCardLimitInRow = useCardLimitInRow(rowRef, () => props.rowSizeLimit);

const fetchPurchaseAgainItems = async (): Promise<void> => {
  try {
    const ps = platform.value.isMobile ? props.rowSizeLimit : getCardLimitInRow();
    const response = await axios.post('api/me/items', {
      hs: props.historyWindowDays,
      pn: 1,
      ps,
      s: '',
    });

    if (response.data.code !== 0) {
      return;
    }

    const items = response.data.data
      .map((row: { item: ItemDetail }) => row.item)
      .filter((item: ItemDetail) => !item.discontinued);

    products.value = items;
    totalCount.value = response.data.totalCount ?? items.length;

    if (items.length > 0) {
      AnalyticsService.track(TrackableEventConstants.ItemImpression, {
        items,
        customerId: getUser.value?.sub,
        listId: 'purchase-again',
        listName: t('purchaseAgainRowTitle'),
      });
    }
  } catch (error) {
    console.error(error);
  }
};

onMounted(() => {
  if (!canShowPurchaseAgain.value) {
    return;
  }

  fetchPurchaseAgainItems();
});

return (_ctx: any,_cache: any) => {
  return (canShowPurchaseAgain.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "rowRef",
        ref: rowRef,
        class: "wc-purchase-again"
      }, [
        (products.value.length > 0)
          ? (_openBlock(), _createBlock(WCProductRowModern, {
              key: 0,
              rowId: "purchase-again",
              rowName: _unref(t)('purchaseAgainRowTitle'),
              items: products.value,
              totalCount: totalCount.value,
              seeAllRoute: "/me/items",
              entryMethod: _ctx.entryMethod
            }, null, 8, ["rowName", "items", "totalCount", "entryMethod"]))
          : _createCommentVNode("", true)
      ], 512))
    : _createCommentVNode("", true)
}
}

})